// import components
import { Button } from '@mui/material';
import { Dialog } from 'components/shared/index';
import { SmartAction } from 'components/shared/DialogProvider/dialogs/SmartActionDialog/components/SmartAction/SmartAction';

// import external libraries
import { useTranslation } from 'react-i18next';

// import styles
import { SmartActionState } from 'components/shared/DialogProvider/dialogs/SmartActionDialog/SmartActionDialog.types';
import { ContentContainer } from 'components/shared/DialogProvider/dialogs/SmartActionDialog/SmartActionDialog.styles';
import { ActionsContainer } from 'components/shared/DialogProvider/dialogs/styles';
import { NotificationList } from './NotificationConfirmationDialog.styles';

// import types
import type { NotificationConfirmationDialogProps } from './NotificationConfirmationDialog.types';

/**
 * Shows the notifications the backend returned for an appointment edit (e.g. "employee outside working
 * hours") and lets the planner decide whether to carry it out anyway — the same soft-block confirmation
 * afsprakenplanning gives. Confirming re-sends the edit with its warnings suppressed.
 */
const NotificationConfirmationDialog = ({
  open,
  title,
  description,
  messages,
  confirmLabel,
  onConfirm,
  onCancel
}: NotificationConfirmationDialogProps) => {
  'use memo';

  const { t } = useTranslation('common');

  return (
    <Dialog open={open} handleClose={onCancel} title={title}>
      <ContentContainer>
        <SmartAction state={SmartActionState.ACTIVE} title={description}>
          <NotificationList>
            {messages.map((message, index) => (
              <li key={`${index}-${message}`}>{message}</li>
            ))}
          </NotificationList>
        </SmartAction>

        <ActionsContainer>
          <Button variant="text" fullWidth onClick={onCancel}>
            {t('cancel')}
          </Button>
          <Button fullWidth onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </ActionsContainer>
      </ContentContainer>
    </Dialog>
  );
};

export default NotificationConfirmationDialog;
